import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';
const topics = ['Science', 'Manicure', 'Gel', 'Acrylic', 'E-File', 'Assessment'];
const highlights = ['150 Ready-to-Teach Lessons', '6 Complete Volumes', '5 Practical Bonuses'];
const assurances = ['Instant Digital Access', 'Ready-to-Use PDF Resources', 'Designed for Nail Educators', 'One-Time Payment'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-104" data-mp="1uddpomyjx1pu">
      <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="1qbiodigmeoc2">
        <p className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-106" data-mp="1qa7o3smdvypp">
          {topics.map((topic, index) => <React.Fragment key={topic} data-id="element-107" data-mp="9vpi6tb2qghc" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="text-brand-gold" data-id="element-108" data-mp="38gkz5rbdwf02">•</span>}
              <span data-id="element-109" data-mp="38eib3ctskvxz">{topic}</span>
            </React.Fragment>)}
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-110" data-mp="3ddbo74562kxm">
          Stop Building Every Nail Class From Scratch.
          <span className="mt-1 block font-semibold italic text-brand-gold" data-id="element-111" data-mp="34gklwa00u9ul">
            For Nail Educators, Instructors & Academy Owners
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-112" data-mp="2ui4q3tq1ucer">
          Get a complete ready-to-teach system to explain techniques, demonstrate procedures,
          correct student mistakes, organize practice and assess progress.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-113" data-mp="26rr9czcwzzzh">
          Nail Educator Ready™ gives you a structured library of professional nail education
          resources you can open, follow and use in your classes — without spending hours creating
          your own teaching materials.
        </p>
      </div>

      <div className="relative mx-auto mt-10 w-full max-w-[1000px]" data-id="element-114" data-mp="8gqozv3bkyg3">
        <div aria-hidden="true" className="absolute inset-x-[6%] bottom-[4%] top-[18%] rounded-[50%] bg-brand-oatmeal opacity-80 blur-3xl" data-id="element-115" data-mp="3ip9fk53rh9d" />
        <img src={MOCKUP_URL} alt="Nail Educator Ready — six teaching volumes shown on books, tablet, desktop and phone" width={1536} height={1024} loading="eager" decoding="async" className="relative mx-auto block w-full max-w-[560px] object-contain lg:max-w-[880px]" style={{
        filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
      }} data-id="element-116" data-mp="106lt4xvu6sot" />
      </div>

      <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-8 gap-y-2" role="list" data-id="element-117" data-mp="36ymmq1yk95bx">
        {highlights.map(item => <li key={item} className="font-display text-[1.3rem] font-bold text-brand-charcoal sm:text-[1.45rem]" data-id="element-118" data-mp="2wwsflbjpk9rx">
            {item}
          </li>)}
      </ul>

      <CtaBlock label="Yes! I Want Nail Educator Ready™" className="mt-8" data-id="element-119" data-mp="36t547v0ebxft" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-120" data-mp="3bjvb5coh08cm">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-121" data-mp="3fmi63mgfu9e1">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-122" data-mp="3kjs6ty9a27h6" />
            {item}
          </li>)}
      </ul>
    </section>;
}